'use strict';

const regex = /[<>]/

module.exports = function(input){
  return !regex.test(input) && input.length < 400 && input.length > 0;
};






